/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Info, AlertTriangle, AlertCircle, X } from "lucide-react";
import { api } from "@/lib/api";

const PRIORITY = {
  INFORMATIONAL: { color: "var(--rg-sage)", Icon: Info },
  IMPORTANT: { color: "var(--rg-amber)", Icon: AlertTriangle },
  URGENT: { color: "var(--rg-red)", Icon: AlertCircle },
};

const DISMISS_KEY_PREFIX = "regulens_banner_dismissed_";
const COOLDOWN_DAYS = 7;

export default function DashboardBanner() {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    api.get("/dashboard/banner").then(({ data }) => {
      const b = data?.banner;
      if (!b) return;
      const dismissedAt = localStorage.getItem(DISMISS_KEY_PREFIX + b.id);
      if (dismissedAt) {
        const elapsed = (Date.now() - new Date(dismissedAt).getTime()) / 86400000;
        if (elapsed < COOLDOWN_DAYS) return;
      }
      setBanner(b);
    }).catch(() => {});
  }, []);

  if (!banner) return null;
  const meta = PRIORITY[banner.priority] || PRIORITY.INFORMATIONAL;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY_PREFIX + banner.id, new Date().toISOString());
    setBanner(null);
  };

  return (
    <div
      className="rounded-md border px-4 py-3 mt-3 mb-6 flex items-start gap-3"
      style={{ borderColor: meta.color, background: `${meta.color}1A` }}
      data-testid="dashboard-banner"
    >
      <meta.Icon className="w-5 h-5 mt-0.5 shrink-0" style={{ color: meta.color }} />
      <div className="flex-1 text-sm">
        <span className="text-[var(--rg-text-strong)]">{banner.text}</span>
        {banner.article_title && (
          <span className="text-[var(--rg-text)] ml-2">| {banner.article_title} →</span>
        )}
      </div>
      <button
        type="button"
        onClick={dismiss}
        className="text-[var(--rg-muted)] hover:text-[var(--rg-text-strong)]"
        aria-label="Dismiss"
        data-testid="dashboard-banner-dismiss"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
